import { ColDef } from "ag-grid-community";
import { jiraIssuesColumnDef } from "../common/jiraIssuesColumnDef";
import { tagsColumnDef } from "../common/tagsColumnDef";
import { smartTagsColumnDef } from "../common/smartTagsColumnDef";
import { forecastedEOMColumnDef } from "../common/forecastedEOMColumnDef";
import { resourceAccountColumnDef } from "../common/resourceAccountColumnDef";
import { resourceTotalSpendColumnDef } from "../common/resourceTotalSpendColumnDef";
import { getResourceCreationTimeColumnDef } from "../common/getResourceCreationTimeColumnDef";
import { getResourceSizeColumnDef } from "../common/getResourceSizeColumnDef";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";
import { taskColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/taskColumnDef";
import { billingCostColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/billingCostColumnDef";
import { getListingPriceColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/listingPriceColumnDef";

export const diskColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef("Disk Name"),

  { field: "resource.type", headerName: "Disk Type" },

  forecastedEOMColumnDef,
  billingCostColumnDef,
  getListingPriceColumnDef("disk"),

  resourceAccountColumnDef,

  resourceTotalSpendColumnDef,

  getResourceCreationTimeColumnDef("Launch time"),

  getResourceSizeColumnDef(),

  {
    field: "resource.state",
    headerName: "State",
  },

  { field: "resource.availability_zone", headerName: "Av. Zone" },
  tagsColumnDef,
  smartTagsColumnDef,
  taskColumnDef,
  jiraIssuesColumnDef,
];
